import { layoutConstants } from "../constants/layout.constants";

/* eslint-disable func-style */
export const layoutActions = {
  setScrolledToBottom,
};

function setScrolledToBottom(isScrolled) {
  return (dispatch) => {
    dispatch({
      type: layoutConstants.LAYOUT_SCROLLED_TO_BOTTOM,
      payload: isScrolled,
    });
  };
}
